"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActivityChallenge = exports.isGoalChallenge = exports.ChallengeKinds = void 0;
// Goal challenges:
//
// 1. User checks the box of a goal on a challenge
// 2. Persist whether they checked the box on the challenge or a subcollection
//   1. Could probably store it right on the challenge? Except they can't write
//   to the challenge.
//   1. Or store it directly on the user's profile? Similar to activity logs.
//   1. Or store it as an actual activity log with some correlation to the
//   challenge itself :thinking:
//     1. like `challengeGoal` with value as ID
//     1. so checking/unchecking would create/delete the ActivityLog
//     1. which may or may not actually delete the newsfeed post but w/e
exports.ChallengeKinds = {
    GoalChallenge: "GoalChallenge",
    ActivityChallenge: "ActivityChallenge",
};
var isGoalChallenge = function (c) {
    return c.kind === exports.ChallengeKinds.GoalChallenge;
};
exports.isGoalChallenge = isGoalChallenge;
var isActivityChallenge = function (c) {
    return c.kind === exports.ChallengeKinds.ActivityChallenge;
};
exports.isActivityChallenge = isActivityChallenge;
//# sourceMappingURL=Challenge.js.map